'use client';

import Drawer from '@/features/drawer';
import { IconClose } from '@/components/svg-symbols/icons';
import { useBasicMetas } from '@/app/(plp)/_utils/use-basic-metas';
import usePLPData from '@/app/(plp)/_utils/use-plp-data';
import { usePLPFacetsContext } from '@/app/(plp)/facets-context/facets-context';
import { toNumberCommas } from '@/utils/string-helpers';
import { MobileFacetDrawerName } from './constants';
import MobileFacetLoading from './mobile-facet-loading';
import { useProductsCount } from './utils/use-products-count';
import { Button, FilterButton } from '../button';
import { useDrawer } from '../drawer/context/use-drawer';
import { AppButton } from '../product-card/app-button';
interface Props {
  children: React.ReactNode;
  onAppliedFacetsChange: () => void;
}
export function MobileFacet({
  children,
  onAppliedFacetsChange
}: Props) {
  const {
    activeFacets,
    allFacets
  } = usePLPFacetsContext();
  const {
    productsCount,
    isLoadingProductsCount
  } = useProductsCount();
  const {
    isLoading: isLoadingProductData
  } = usePLPData();
  const isLoadingBasicMetas = useBasicMetas().isLoadingBasicMetas;
  const {
    openDrawer,
    closeDrawer
  } = useDrawer();
  const applyFilters = () => {
    onAppliedFacetsChange();
    closeDrawer(MobileFacetDrawerName);
  };
  if (isLoadingProductData || isLoadingBasicMetas) return <MobileFacetLoading />;
  const appliedFiltersCount = activeFacets?.count;
  if (!allFacets) return null;
  return <>
            <label onClick={() => openDrawer(MobileFacetDrawerName)} className='flex cursor-pointer items-center gap-1 text-red-300 lg:hidden'>
                <FilterButton appliedFiltersCount={appliedFiltersCount || 0} data-sentry-element="FilterButton" data-sentry-source-file="mobile-facet.tsx" />
            </label>
            <Drawer position='bottom' name={MobileFacetDrawerName} className='hide-scrollbar grow' data-sentry-element="Drawer" data-sentry-source-file="mobile-facet.tsx">
                <div className='relative flex w-full items-center justify-center p-4 text-text-black shadow-sm'>
                    <span className='text-body-16 font-medium'>فیلترها</span>

                    <IconClose className='absolute left-4 h-6 w-6 cursor-pointer' onClick={applyFilters} data-sentry-element="IconClose" data-sentry-source-file="mobile-facet.tsx" />
                </div>

                <div className='hide-scrollbar flex h-[calc(100dvh_-_133px)] grow flex-col gap-3 overflow-auto px-2 py-3'>
                    {children}
                </div>

                <AppButton className='sticky bottom-0 right-0' isSingleButton data-sentry-element="AppButton" data-sentry-source-file="mobile-facet.tsx">
                    <Button size='large' graphicStyle='filled' onClick={applyFilters} isLoading={isLoadingProductsCount} data-sentry-element="Button" data-sentry-source-file="mobile-facet.tsx">
                        {!!productsCount || productsCount === 0 ? `اعمال فیلترها و مشاهده ${toNumberCommas(productsCount)} کالا` : 'اعمال فیلترها'}
                    </Button>
                </AppButton>
            </Drawer>
        </>;
}
export default MobileFacet;